module.exports = __webpack_public_path__ + "img/character_cv.6fc0cde4.png";